import { validateNotification } from "../common/validators/notificationValidator";
import { validateChannel } from "../common/validators/channelValidator";

export default class ValidateUtils {
    static validateNotification(notification, fields = null, exactFields = true, required = false) {
        const validationResults = validateNotification(notification, false);
        if (required) {
            this.processRequiredFields(notification, fields, validationResults);
        }
        return this.processValidationResults(validationResults, fields, exactFields);
    }

    static validateChannel(channel, fields = null, exactFields = true, required = false) {
        const validationResults = validateChannel(channel, false);
        if (required) {
            this.processRequiredFields(channel, fields, validationResults);
        }
        return this.processValidationResults(validationResults, fields, exactFields);
    }

    static processRequiredFields(data, fields, validationResults) {
        if (!Array.isArray(fields)) {
            fields = [fields];
        }
        fields.forEach((f) => {
            if (!!f && !f.startsWith("!")) {
                if (data[f] === undefined) {
                    validationResults.push({ fields: [f], message: `${t("Required field is missing")} ${f}` });
                }
            }
        });
    }

    static processValidationResults(validationResults, fields, exactFields) {
        if (fields === null) {
            fields = [];
        }
        if (!Array.isArray(fields)) {
            fields = [fields];
        }
        if (!validationResults) {
            return "";
        }

        const validationErrors = [];
        const ignoreFields = new Set(fields.filter((f) => !!f && f.startsWith("!")).map((f) => f.substring(1)));
        const checkFields = new Set(fields.filter((f) => !!f && !f.startsWith("!")));

        for (const validationResult of validationResults) {
            if (validationResult.fields.some((f) => ignoreFields.has(f))) {
                continue;
            }
            if (
                checkFields.size === 0 ||
                (!exactFields && validationResult.fields.some((f) => checkFields.has(f))) ||
                (exactFields && validationResult.fields.every((f) => checkFields.has(f)))
            ) {
                validationErrors.push(t(validationResult.message));
            }
        }
        return validationErrors.join(". ");
    }
}
